const counter = 0
const scriptMap = new Map()

export const ScriptCache = (function ScriptCache(global) {
  return function ScriptCacheFunc(scripts) {
    const Cache = {}

    Cache._onLoad = function _onLoad(key) {
      return (cb) => {
        const stored = scriptMap.get(key)
        if (stored) {
          stored.promise.then(() => {
            if (stored.error) {
              cb(stored.error)
            } else {
              cb(null, stored)
            }
          })
        } else {
          // TODO:
        }
      }
    }

    Cache._scriptTag = (key, srcParam) => {
      let src = srcParam
      if (!scriptMap.has(key)) {
        const tag = document.createElement('script')
        const promise = new Promise((resolve, reject) => {
          const body = document.getElementsByTagName('body')[0]
          tag.type = 'text/javascript'
          tag.async = false // Load in order
          const cbName = `loaderCB${counter + 1}${Date.now()}`
          const handleResult = state => (evt) => {
            const stored = scriptMap.get(key)
            if (state === 'loaded') {
              stored.resolved = true
              resolve(src)
              // stored.handlers.forEach(h => h.call(null, stored))
              // stored.handlers = []
            } else if (state === 'error') {
              stored.errored = true
              // stored.handlers.forEach(h => h.call(null, stored))
              // stored.handlers = [];
              reject(evt)
            }
            // cleanup
            if (global[cbName] && typeof global[cbName] === 'function') {
              // eslint-disable-next-line
              global[cbName] = null
            }
          }

          tag.onload = handleResult('loaded')
          tag.onerror = handleResult('error')
          tag.onreadystatechange = () => {
            handleResult(tag.readyState)
          }

          // Pick off callback, if there is one
          if (src.match(/callback=CALLBACK_NAME/)) {
            src = src.replace(/(callback=)[^&]+/, `$1${cbName}`)
            window[cbName] = tag.onload
          } else {
            tag.addEventListener('load', tag.onload)
          }
          tag.addEventListener('error', tag.onerror)

          tag.src = src
          body.appendChild(tag)
          return tag
        })
        const initialState = {
          loaded: false,
          error: false,
          promise,
          tag,
        }
        scriptMap.set(key, initialState)
      }
      return scriptMap.get(key)
    }

    Object.keys(scripts).forEach((key) => {
      const script = scripts[key]
      Cache[key] = {
        tag: Cache._scriptTag(key, script),
        onLoad: Cache._onLoad(key),
      }
    })

    return Cache
  }
}(window))

export default ScriptCache



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/lib/ScriptCache.js